var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BjDrawerForm",
    {
      ref: "BjDrawerForm",
      staticClass: "bj-label-colon",
      attrs: { form: _vm.form, rules: _vm.rules, width: "628px" },
      on: { handleConfirm: _vm.handleConfirm },
    },
    [
      _c("BjDivider", [_vm._v(_vm._s(_vm.$t("BusinessLabelHandPage.title")))]),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 21 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("BusinessLabelHandPage.labelName"),
                    prop: "labelName",
                  },
                },
                [
                  _c("BjInput", {
                    attrs: {
                      maxlength: _vm.MAX_LENGTH.DEFAULT,
                      placeholder: _vm.$t("inputText"),
                      clearable: "",
                    },
                    model: {
                      value: _vm.form.labelName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "labelName", $$v)
                      },
                      expression: "form.labelName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 21 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("BusinessLabelHandPage.labelType"),
                    prop: "labelType",
                  },
                },
                [
                  _c("BjSelectLov", {
                    attrs: {
                      disabled: _vm.isEdit,
                      "option-list": _vm.LABEL_SYS_TYPES_STRING,
                    },
                    model: {
                      value: _vm.form.labelType,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "labelType", $$v)
                      },
                      expression: "form.labelType",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("BjDivider", [
        _vm._v(_vm._s(_vm.$t("BusinessLabelHandPage.labelStyle"))),
      ]),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 21 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("BusinessLabelHandPage.textContent"),
                    prop: "textContent",
                  },
                },
                [
                  _c("BjInput", {
                    attrs: {
                      maxlength: _vm.MAX_LENGTH.DEFAULT,
                      placeholder: _vm.$t(
                        "BusinessLabelHandPage.textContentText"
                      ),
                      clearable: "",
                    },
                    model: {
                      value: _vm.form.textContent,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "textContent", $$v)
                      },
                      expression: "form.textContent",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "bj-tag-color-20211104", attrs: { span: 21 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("BusinessLabelHandPage.textColor"),
                    prop: "textColor",
                  },
                },
                [
                  _c("BjRadioLov", {
                    attrs: { "option-list": _vm.LABEL_HAND_COLORS },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var item = ref.item
                          return [
                            _c("BjTag", {
                              staticClass: "tag-color",
                              attrs: { color: item.value },
                            }),
                          ]
                        },
                      },
                    ]),
                    model: {
                      value: _vm.form.textColor,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "textColor", $$v)
                      },
                      expression: "form.textColor",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 21 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("BusinessLabelHandPage.preview"),
                    prop: "yulan",
                  },
                },
                [
                  _c("BjTag", {
                    attrs: {
                      color: _vm.form.textColor,
                      text: _vm.form.textContent,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }